import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCurrentVenue } from "../../redux/slices/currentUserSlice";
import { getVenueTimezone } from "../../utils/venueTimeFormatters";
import { VenueClockContainer,
   ClockTime,
    ClockTimezone,
    VenueTimeRow,
    VenueTimeLabel
   } from "./VenueClock.styles";

const VenueClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const currentVenue = useSelector(selectCurrentVenue);

  useEffect(() => {
    const clockInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(clockInterval);
  }, []);

  const venueTimezone = getVenueTimezone(currentVenue);

  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: venueTimezone,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  const timezoneFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: venueTimezone,
    timeZoneName: 'short'
  });

  const formattedTime = timeFormatter.format(currentTime);
  const timezoneParts = timezoneFormatter.formatToParts(currentTime);
  const timezoneAbbr = timezoneParts.find(part => part.type === 'timeZoneName')?.value || venueTimezone;

  return (
    <VenueClockContainer>
            <VenueTimeRow>
              <VenueTimeLabel>Venue Time</VenueTimeLabel>
              <ClockTime>{formattedTime}</ClockTime>
            </VenueTimeRow>
            <ClockTimezone>{timezoneAbbr}</ClockTimezone>
          </VenueClockContainer>
  );
};

export default VenueClock;
